import React from 'react'

import { useBrandHeadersInfo } from '../../../domains/brand'
import { useShouldRemoveMerchandisingBanner } from '../useShouldRemoveMerchandisingBanner'
import { MerchandisingHeader } from './MerchandisingHeader'
import { useCollectionHeaders } from './hooks'

const CollectionHeaderWrapper = () => {
  const { headers, collectionsPerMenu } = useBrandHeadersInfo()
  const collectionsHeaders = useCollectionHeaders(headers, collectionsPerMenu)

  const removeMerchandisingBanner = useShouldRemoveMerchandisingBanner()

  if (!collectionsHeaders || removeMerchandisingBanner) {
    return null
  }

  return <MerchandisingHeader header={collectionsHeaders} />
}

export { CollectionHeaderWrapper }
